import React, { memo } from 'react';
import { ReactMarkdownDisplay } from '../../../PageElements/ReactMarkdownDisplay';
import { generateTableOfContentFromMarkdown } from './utils';
import { getMarkdownPath } from '../../../../../utils/markdownUtils';
import style from './MarkdownTableOfContent.scss';

interface MarkdownTableOfContentProps {
  markdown: string;
  mdName: string;
  mdUrlFormat: string;
  prefix: string;
}

function MarkdownTableOfContent({
  markdown,
  mdName,
  mdUrlFormat,
  prefix,
}: MarkdownTableOfContentProps) {
  const markdownPath = getMarkdownPath(mdName, prefix);
  return (
    <ReactMarkdownDisplay
      markdown={markdown}
      mdName={mdName}
      mdUrlFormat={mdUrlFormat}
      prefix={prefix}
      className={style.tocContainer}
      renderers={{
        root: generateTableOfContentFromMarkdown({ markdownPath }),
      }}
    />
  );
}

export default memo(MarkdownTableOfContent);
